import { render, staticRenderFns } from "./DatasetPermissionsForm.vue?vue&type=template&id=7e036afb"
import script from "./DatasetPermissionsForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DatasetPermissionsForm.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports